import { authorizeIfLoggedIn } from "../../../components/Auth/AuthorizedApiClientBase";
import { EducationClient } from "./generated/EducationClient"

export const EducationClientFactory = () => {
    const propertyClient = new EducationClient(process.env.EDUCATION_BACKEND_URL);
    authorizeIfLoggedIn(propertyClient);

    return propertyClient;
}